import React, { Component } from 'react';
import { StyleSheet, css } from 'aphrodite';
import Dialog from '@material-ui/core/Dialog';

import { AppStyles, AppTheme } from '../styles/AppTheme';
import { CustomMessageDialogStyles } from '../styles/CustomStyles';
import { AppConfig } from '../AppConfig';
import { UiHelper } from '../common/helpers/UiHelper';
import { Chip, FormControl, FormControlLabel, Grid, MenuItem, Radio, RadioGroup, TextField } from '@material-ui/core';
import { ExpressionHelper } from '../common/helpers/ExpressionHelper';
import Autocomplete from '@material-ui/lab/Autocomplete';
import { AppButton } from '../common/components/AppButton';
import { Helper } from '../common/helpers/Helper';
import { ApiHelper } from '../common/helpers/ApiHelper';


import { Fade, Slide } from '@material-ui/core';
import { AppHelper } from '../helpers/AppHelper';
const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction='up' ref={ref} {...props} />;
});

export class ExpressionDialog extends Component {

  constructor(props) {
    super(props)

    // Check if expression is present, then prefill
    if (this.props.current && this.props.current.expressionJSON) {
      this.expressionHelper = new ExpressionHelper(this._preloadFunction())
    } else {
      this.expressionHelper = new ExpressionHelper()
    }

    this.state = {
      expressionInvokeTypeOptions: this.expressionHelper.getBaseConditions(),
      selectedCondition: [],
      conditions: [
        { key: 'and', text: 'AND' },
        { key: 'or', text: 'OR' },
        { key: 'and not', text: 'AND NOT' },
      ],
      expressionConditions: this.expressionHelper.getExpression(),
      fieldKey: this.generateKeys(),
      selectedTags: [],
      selectedCustomFields: [],
      inProcess: false,
      errMsg: ''
    }
  }

  _preloadFunction = () => {
    const expressionConditions = this.props.current.expressionJSON.expression || []
    expressionConditions.map((expression) => {
      if (expression && expression.expressionKey && expression.expressionKey.key === 'tagsPartner') {
        expression.expressionValueOptions = this.getTagsAsOptions()
      }
      if (expression && expression.expressionKey && expression.expressionKey.key !== 'tagsPartner') {
        expression.expressionValueOptions = this.getCfsSuggestionsOptions(expression.expressionKey.key)
      }
    })
    console.log('_preloadFunction', this.props.current.expressionJSON.baseCondition)
    return {
      baseCondition: this.props.current.expressionJSON.baseCondition,
      rules: expressionConditions
    }
  }

  generateKeys = () => {
    const keysOptions = [{ key: 'tagsPartner', text: 'Tag' }]
    if (!this.props.customFields || !this.props.customFields.length) return keysOptions
    this.props.customFields.forEach(e => {
      keysOptions.push({ key: e.id, text: e.title })
    })
    return keysOptions;
  }

  getTagsAsOptions = () => {
    if (!this.props.tags || !this.props.tags.length) return []
    const keysOptions = []
    this.props.tags.forEach(e => {
      keysOptions.push({ key: e.id, text: e.title })
    })
    return keysOptions;
  }

  getCfsSuggestionsOptions = (csfId) => {
    if (!this.props.customFields || !this.props.customFields.length) return []
    const matchedField = this.props.customFields.find(field => field.id === csfId);
    if (!matchedField || !matchedField.suggestions) {
      return [];
    }
    return Object.values(matchedField.suggestions).map(suggestion => ({
      key: suggestion.id,
      text: suggestion.title
    }));
  }

  filteredOptions = (field, options) => {
    const { selectedTags, selectedCustomFields } = this.expressionHelper.getSelectedTagsAndCfs()
    if (field && field.expressionKey && field.expressionKey.key === 'tagsPartner') {
      return options.filter(option => {
        const checkExist = !selectedTags.some(item => item.key === option.key)
        return checkExist
      });
    }
    if (field && field.expressionKey && field.expressionKey.key !== 'tagsPartner') {
      return options.filter(option => {
        const checkExist = !selectedCustomFields.some(item => item.key === option.key)
        return checkExist
      });
    }
  }

  updateExpressionState = (field, index, fieldType = null) => {
    const expressionConditions = [...this.state.expressionConditions.rules]
    if (fieldType === 'expressionKey') {
      // Generate Tags
      if (
        expressionConditions[index] &&
        expressionConditions[index].expressionKey &&
        expressionConditions[index].expressionKey.key === 'tagsPartner'
      ) {
        expressionConditions[index].expressionValueOptions = this.getTagsAsOptions();
      }
      // Generate Custom Fields
      if (
        expressionConditions[index] &&
        expressionConditions[index].expressionKey &&
        expressionConditions[index].expressionKey.key !== 'tagsPartner'
      ) {
        expressionConditions[index].expressionValueOptions = this.getCfsSuggestionsOptions(expressionConditions[index].expressionKey.key);
      }

      // On key Change clear the selection value
      expressionConditions[index].expressionValue = null
    }
    this.setState(expressionConditions)
  }

  onCloseModal() {
    this.props.onClosed()
  }

  invokeTypeChange = (e, v) => {
    const expressionConditions = this.expressionHelper.updateBaseCondition(e.target.value)
    this.setState(expressionConditions)
  }

  addRule = () => {
    const expressionConditions = this.expressionHelper.addRule()
    this.setState(expressionConditions)
  }

  removeExpression = (index) => {
    const expressionConditions = this.expressionHelper.removeRule(index)
    this.setState(expressionConditions)
  }

  saveExpression = async () => {
    this.setState({ inProcess: true })
    const savableExpression = this.expressionHelper.getSaveableExpression()
    console.log('savableExpression', savableExpression)
    const payload = {
      expressionJSON: {
        baseCondition: savableExpression.baseCondition,
        expression: savableExpression.rules
      }
    }
    // Job API Call
    ApiHelper.call({
      method: 'PUT',
      endPoint: ApiHelper.makeUrlPath(['assets', this.props.current.id]),
      jsonBody: payload,
    }, (err, result) => {
      console.log(err, result)
      if (err) {
        const errorMessage = Helper.getErrorMsg(err)
        this.setState({
          errMsg: errorMessage,
          inProcess: false
        })
        return
      }
      this.setState({ inProcess: false, errMsg: '' })
      // Close the modal
      this.props.onCompleteAction && this.props.onCompleteAction()
      // this.props.caller.setState({ previewExpression: false })
      // this.props.caller.fetchItems()
    })
  }

  render() {
    return (
      <Dialog
        open={this.props.isOpen}
        aria-labelledby={this.props.title}
        fullWidth={AppHelper.fullWidthCondition()}
        fullScreen={AppHelper.fullWidthCondition()}
        TransitionComponent={window.innerWidth < 1024 ? Transition : Fade}
        maxWidth='md'
        classes={{
          root: css(Styles.root),
          paper: css(Styles.paper),
        }}
      >
        <div className={css([Styles.modalHeader, AppStyles.modalHeader])}>
          <div className={css(Styles.modalTitle)}>{this.props.title}</div>
          <button className={css(Styles.modalCloseButton)} onClick={this.onCloseModal.bind(this)} disabled={this.state.inProcess}>
            {UiHelper.renderImg({ key: 'dialogCloseIcon' })}
          </button>
        </div>
        <div className={css(Styles.modalContent)}>
          {/* Expression */}
          <div className={css(Styles.expressionQuery)}>
            <b>Expression:</b> <code> {this.expressionHelper.toString()}</code>
          </div>
          {/* Expression Invoke Type */}
          <div className={css(Styles.invokeOptionsBlock)}>
            <Grid container>
              <Grid item md={8}>
                <FormControl component='expressionType'>
                  <RadioGroup
                    row
                    value={this.state.expressionConditions.baseCondition}
                    onChange={this.invokeTypeChange}>

                    {this.state.expressionInvokeTypeOptions && this.state.expressionInvokeTypeOptions.map((e) => {
                      return (
                        <FormControlLabel
                          value={e.value}
                          control={<Radio color={'primary'} />}
                          label={e.label}
                        />)
                    })}
                  </RadioGroup>
                </FormControl>
              </Grid>
              <Grid item md={4} className={css(Styles.addRuleBlock)}>
                <AppButton
                  buttonStyle={Styles.infoButton}
                  disabled={!this.state.expressionConditions.rules || this.state.expressionConditions.rules.length < 1}
                  onClick={this.addRule}
                  buttonText={this.props.buttonText || Helper.getString('addRule')}
                />
              </Grid>
            </Grid>
          </div>
          {/* Expression Fields */}
          <div className={css(Styles.invokeOptionsBlock)}>
            {this.generateExpressionFields()}
          </div>
          {/* Add Rule */}
          <div className={css(Styles.actionButtonHolder)}>
            <div className={css(Styles.errorMessage)} >{this.state.errMsg || ''}</div>
            <AppButton
              inProcess={this.state.inProcess}
              disabled={!this.expressionHelper.isValidExpression()}
              onClick={this.saveExpression}
              buttonText={this.props.buttonText || Helper.getString('saveExpression')}
            />
          </div>
        </div>
      </Dialog>
    );
  }

  generateExpressionFields = () => {
    const expression = this.state.expressionConditions.rules;
    if (!expression || expression.length < 1) return null
    return expression.map((field, i) => {
      return (
        <div key={i} className={css(Styles.expressionRow)}>
          <Grid container spacing={1}>
            {i > 0 && (
              <Grid item md={3}>
                {/* Operator */}
                <div className={css(Styles.textBoxContainer)}>
                  <Autocomplete
                    value={field.operator || {}}
                    options={this.state.conditions}
                    getOptionLabel={(option) => option.title || option.text}
                    renderTags={(value, getTagProps) =>
                      value.map((option, index) => (
                        <Chip variant='outlined' label={option.title || option.text} {...getTagProps({ index })} />
                      ))
                    }
                    onChange={(e, val) => {
                      field.operator = val
                      this.updateExpressionState(field, i)
                    }}
                    renderInput={(params) => (
                      <TextField {...params}
                        placeholder={''}
                        className={css(Styles.textFeildStyle, Styles.selectStyle)}
                        InputProps={{
                          ...params.InputProps,
                          disableUnderline: true,
                          classes: {
                            root: css(Styles.textInputStyles, Styles.selectInputStyle)
                          }
                        }} />
                    )}
                  />
                </div>
              </Grid>
            )}
            <Grid item md={i === 0 ? 6 : 4}>
              <div className={css(Styles.textBoxContainer)}>
                <Autocomplete
                  fullWidth
                  value={field.expressionKey || []}
                  options={this.state.fieldKey || []}
                  getOptionLabel={(option) => option.title || option.text}
                  renderTags={(value, getTagProps) =>
                    value.map((option, index) => (
                      <Chip variant='outlined' label={option.title || option.text} {...getTagProps({ index })} />
                    ))
                  }
                  onChange={(e, val) => {
                    field.expressionKey = val
                    this.updateExpressionState(field, i, 'expressionKey')
                  }}
                  renderInput={(params) => (
                    <TextField {...params}
                      placeholder={''}
                      className={css(Styles.textFeildStyle, Styles.selectStyle)}
                      InputProps={{
                        ...params.InputProps,
                        disableUnderline: true,
                        classes: {
                          root: css(Styles.textInputStyles, Styles.selectInputStyle)
                        }
                      }} />
                  )}
                />
              </div>
            </Grid>
            <Grid item md={i === 0 ? 6 : 4}>
              <div className={css(Styles.textBoxContainer)}>
                <Autocomplete
                  fullWidth
                  value={field.expressionValue || []}
                  options={this.filteredOptions(field, field.expressionValueOptions) || []}
                  getOptionLabel={(option) => option.title || option.text}
                  renderTags={(value, getTagProps) =>
                    value.map((option, index) => (
                      <Chip variant='outlined' label={option.title || option.text } {...getTagProps({ index })} />
                    ))
                  }
                  onChange={(e, val) => {
                    field.expressionValue = val
                    this.updateExpressionState(field, i)
                  }}
                  renderInput={(params) => (
                    <TextField {...params}
                      placeholder={''}
                      className={css(Styles.textFeildStyle, Styles.selectStyle)}
                      InputProps={{
                        ...params.InputProps,
                        disableUnderline: true,
                        classes: {
                          root: css(Styles.textInputStyles, Styles.selectInputStyle)
                        }
                      }} />
                  )}
                />
              </div>
            </Grid>
            {i > 0 &&
              <Grid item md={1} className={css(Styles.actionColumn)}>
                <span onClick={() => this.removeExpression(i)}>
                  <i className={css(Styles.closeIcon) + ' material-icons-outlined '}>close</i>
                </span>
              </Grid>
            }
          </Grid>
        </div>
      );
    });
  };

}

const Styles = AppConfig.CUSTOM_STYLE ? CustomMessageDialogStyles : StyleSheet.create({
  infoButton: {
    background: AppTheme.primaryBg,
    color: AppConfig.TINT_COLOUR
  },
  addRuleBlock: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-end'
  },
  radioExpressionType: {
    marginBottom: 10
  },
  expressionRow: {
    marginBottom: 8
  },
  actionButtonHolder: {
    paddingTop: 14,
    display: 'flex',
    justifyContent: 'space-between'
  },
  actionColumn: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  },
  closeIcon: {
    color: 'tomato',
    cursor: 'pointer'
  },
  // Auto Complete style Starts ---
  textBoxContainer: {
    display: 'flex',
    flexDirection: 'column',
    // marginBottom: 32,
  },
  textFeildStyle: {
    minHeight: 54,
    borderRadius: 16,
    backgroundColor: '#F6F6F8',
  },
  selectStyle: {
    minWidth: 150,
    padding: '0px !important',
    border: '1px solid #E5E5E5',
    textDecoration: 'none',
    borderRadius: AppTheme.borderRadius,
    backgroundColor: 'white',
    minHeight: '46px !important'
  },
  textInputStyles: {
    border: 'none',
    padding: '0px 14px',
    flex: 1,
    textAlign: 'left',
    fontSize: 16,
    color: '#000000',
    '::placeHolder': {
      color: '#747474',
    }
  },
  selectInputStyles: {
    fontSize: 16,
    color: '#000000',
    margin: 0
  },
  // Auto Complete style ends ---
  expressionQuery: {
    padding: '10px',
    background: '#f3f3f3',
    marginBottom: '13px',
    borderRadius: '8px'
  },
  invokeOptionsBlock: {
    marginTop: 2,
    marginBottom: 10
  },
  modalHeader: {
    padding: 20,
    paddingLeft: 30,
    paddingRight: 30,
    paddingBottom: 14
  },
  modalTitle: {
    color: '#222222',
    fontSize: 18,
    maxWidth: 180,
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis'
  },
  modalContent: {
    // maxWidth: 400,
    minWidth: 200,
    paddingTop: 16,
    paddingLeft: 30,
    paddingRight: 30,
    paddingBottom: 30,
  },
  modalCloseButton: {
    position: 'absolute',
    top: 23,
    right: 30,
    padding: 0,
    border: 'none',
    backgroundColor: 'transparent',
    display: 'flex',
    outline: 'none',
    cursor: 'pointer',
  },
  modalCloseIcon: {
    width: 18,
    height: 18,
    padding: 1,
    fill: 'black',
    borderRadius: AppTheme.borderRadius
  },
  root: {
    // zIndex: 99999,
  },
  paper: {
    borderRadius: AppTheme.borderRadius,
    '@media (max-width: 1024px)': {
      maxHeight: 'calc(100% - 140px) !important',
      borderRadius: '20px 20px 0 0',
      bottom: '0 !important',
      position: 'fixed',
      height: 'auto !important'
    }
  },
  errorMessage: {
    color: 'tomato'
  }
})



// WEBPACK FOOTER //
// ./src/components/ExpressionDialog.js